// BUG-066 — Admin -> Quiz reviews: ONE empty-state sentence was shown on all four filter
// tabs, so three of them stated the wrong condition. On Rejected it read "No long answers
// to review" — directly contradicting the counts in the subtitle above it, which were
// showing reviewed answers.
//
// An empty list means something DIFFERENT on each tab: nothing is waiting, nothing has
// been approved, nothing has been rejected, nothing has been submitted at all. Four facts,
// four sentences.
//
// `qr.empty` (admin/base.js) is what these supersede; it is left in place because base.js
// is mechanically generated, but nothing reads it any more — do not reuse it.
export default {
  fr: {
    "qr.empty.pending": "Aucune réponse en attente de relecture.",
    "qr.empty.approved": "Aucune réponse approuvée pour le moment.",
    "qr.empty.rejected": "Aucune réponse rejetée.",
    "qr.empty.all": "Aucune réponse longue n’a encore été soumise.",
  },
  en: {
    "qr.empty.pending": "No answers are waiting to be reviewed.",
    "qr.empty.approved": "No answers have been approved yet.",
    "qr.empty.rejected": "No answers have been rejected.",
    "qr.empty.all": "No long answers have been submitted yet.",
  },
  es: {
    "qr.empty.pending": "No hay respuestas pendientes de revisión.",
    "qr.empty.approved": "Todavía no se ha aprobado ninguna respuesta.",
    "qr.empty.rejected": "No se ha rechazado ninguna respuesta.",
    "qr.empty.all": "Aún no se ha enviado ninguna respuesta larga.",
  },
};
